<div class="line-min-rows">
  @for (rating of ratingValueType; track $index) {
    <div class="rating">
      <div
        class="line-cell stars"
        [class.line-cell-aggregation]="isAggregationRow()"
      >
        @for (star of getStarsArray(rating); track $index) {
          <img
            src="assets/icons/feedback/star.svg"
            width="10"
            height="10"
            [alt]="star"
          >
        }
      </div>
      <div
        class="line-cell line-rating"
        [class.line-cell-aggregation]="isAggregationRow()"
      >
        {{ getRating(rating) }}
      </div>
    </div>
  }
</div>
